export enum MarketingConsentsActionTypes {    
  SET_CLOSED_DIALOG = "@@marketingConsents/SET_CLOSED_DIALOG"
}

export type MarketingConsentsAction = { type: MarketingConsentsActionTypes.SET_CLOSED_DIALOG, data: boolean }

export const setClosedDialog = (isClosedDialog: boolean): MarketingConsentsAction => {
  return {
      type: MarketingConsentsActionTypes.SET_CLOSED_DIALOG,
      data: isClosedDialog
  }
}
